import PopupComponent from './popup-component';
import DropdownComponent from './dropdown-component';
import PairHelpPopup from './pair-help-popup/pair-help-popup';
import PairPopup from './pair-popup/pair-popup';
import RoboFeedbackPopup from './robo-feedback-popup/robo-feedback-popup';
import SetNamePopup from './set-name-popup/set-name-popup';
import FlashPopup from './flash-popup/flash-popup';
import OldFwVersionPopup from './old-fw-version-popup/old-fw-version-popup';

export default {
  PairHelpPopup,
  PairPopup,
  RoboFeedbackPopup,
  PopupComponent,
  SetNamePopup,
  DropdownComponent,
  FlashPopup,
  OldFwVersionPopup,
};
